import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const CitiesTable = ({
  cities,
  setIdMunicipio,
  setOpenModal,
  states,
  setFilter,
  filterState
}) => {
  const columns = [
    {
      accessorKey: 'clave',
      header: 'Clave',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'descripcion',
      header: 'Municipio',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'estado.descripcion',
      header: 'Estado',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idmunicipio',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idmunicipio } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdMunicipio(idmunicipio);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
              variant="falcon-default"
              size="sm"
              title="Eliminar"
              onClick={() => {
                setIdMunicipioToDelete(idmunicipio);
                setOpenConfirm(true);
              }}
            >
              <FontAwesomeIcon icon="trash-alt" />
            </Button> */}
          </>
        );
      }
    }
  ];

  return (
    <>
      <Card className="mb-3">
        <Card.Header>
          <Row className="flex-end-center mb-3">
            <Col xs="auto" sm={6} lg={4}>
              <Form.Label>Filtrar por Estado:</Form.Label>
              <Form.Control
                as="select"
                aria-label="Default select"
                name="idestado"
                id="idestado"
                onChange={e => {
                  setFilter(e.target.value);
                }}
                value={`${filterState}`}
                style={{ minWidth: '250px' }}
              >
                <option key={'location_0'} value="">
                  Selecciona un estado
                </option>
                {!!states?.length &&
                  states.map(estado => (
                    <option key={estado.idestado} value={estado.idestado}>
                      {estado.descripcion}
                    </option>
                  ))}
              </Form.Control>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <GenericTable
            data={cities}
            title="Municipios"
            columns={columns}
            addAction={() => {
              setIdMunicipio(0);
              setOpenModal(true);
            }}
          ></GenericTable>
        </Card.Body>
      </Card>
    </>
  );
};
CitiesTable.propTypes = {
  cities: PropTypes.array.isRequired,
  setIdMunicipio: PropTypes.func.isRequired,
  setOpenModa: PropTypes.func.isRequired,
  setIdMunicipioToDelete: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  setOpenConfirm: PropTypes.func.isRequired,
  states: PropTypes.array,
  setFilter: PropTypes.func,
  filterState: PropTypes.string
};

export default CitiesTable;
